import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { UserStatus } from "../projectDetail/ProjectDetailTaskRow";
import {
  Chip, Collapse, FormControlLabel, Grid, IconButton, InputLabel, Paper, Stack,
  SvgIcon, Switch, TextField, Tooltip, Typography
} from "@mui/material";
import {
  Error as ErrorIcon, ArrowDropDown as ArrowDropDownIcon, ArrowRight as ArrowRightIcon,
  Delete as DeleteIcon, Add as AddIcon, ReportProblem as ReportProblemIcon, Info as InfoIcon
} from "@mui/icons-material";
import { TrueffortButton, TrueffortChip, TrueffortConfirmAlert, TrueffortTextField } from "../../MUIstyle/MUICustom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import ProjectDetailUserCard from "../projectDetail/ProjectDetailUserCard";
import AssignUsersDrawer from "../AssignUsersDrawer";
import { useProjectPlanDispatch } from "./ProjectPlanContext";
import { DurationTypeContext, UsersContext } from "./EstimationPageUtils";
import { confirmAlert } from "react-confirm-alert";
import { useEffect } from "react";
import Limit from "./Limit";
import Select from "react-select";
import { styleReactSelect } from "../../MUIstyle/GlobalStyles";
import DatePicker from 'react-datepicker';
import { formatDateString } from "../../util/DateDataFormat";

export default function CollapsibleActivities(props: any) {
  console.log(props);
  const { t } = useTranslation();

  const projectPlanDispatch = useProjectPlanDispatch();
  const users = useContext(UsersContext);
  const statisticalRange = useContext(DurationTypeContext);

  const [showUsers, setShowUsers] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [changeValuesOnAssignedUsers, setChangeValuesOnAssignedUsers] = useState(false);
  const [durationFocused, setDurationFocused] = useState(false);
  const [effortFocused, setEffortFocussed] = useState(false);
  const [listActivities, setListActivities] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(
    props.task.projectTask.assignedUsers.length
  );
  //console.log(users);
  const [usuariosAsignados, setUsuariosAsignados] = useState(
    users.filter((us: any) => props.task.projectTask.assignedUsers.includes(us.idUser))
      .map((us: any) => { return { ...us, status: UserStatus.Assigned } }));

  const [rankedUsers, setRankedUsers] = useState([]);
  const [notRankedUsers, setNotRankedUsers] = useState([]);

  useEffect(() => {
    setRankedUsers(props.task.taskType.users.map((user: any) => (
      {
        ...user,
        status: props.task.projectTask.assignedUsers.includes(user.id) ?
          UserStatus.Assigned :
          UserStatus.Unassigned
      }
    )));
    setNotRankedUsers(() => {
      const taskUsers = props.task.taskType.users.map((user: any) => user.id);
      return users
        .filter((user: any) => !taskUsers.includes(user.idUser))
        .map((user: any) => (
          {
            id: user.idUser,
            name: user.name,
            lastname: user.lastName,
            email: user.email,
            effort_interp_avg: props.task.taskType.effort_avg,
            image_id: user.imageDto.idImage,
            image_url: user.imageDto.url,
            status: props.task.projectTask.assignedUsers.includes(user.idUser) ?
              UserStatus.Assigned :
              UserStatus.Unassigned
          }
        ))
    });
  }, [props.task.projectTask.assignedUsers]);

  useEffect(() => {
    let list:any = [];
    props.plan.elementTypes.forEach((et:any) => et.projectElements.forEach((pe:any) => 
      pe.projectPhases.forEach((pp:any) => pp.projectTasks.forEach((pt:any) => {if(pt.id != props.task.projectTask.id) {list.push(pt);}}))));
    setListActivities(list);
  }, [props.plan]);

  const [activityEffort, setActivityEffort] = useState(
    props.task.projectTask.estimatedTime
  );
  const [activityDuration, setActivityDuration] = useState(
    Math.round(props.task.projectTask.estimatedDays)
  );

  if (activityEffort !== props.task.projectTask.estimatedTime && !effortFocused) {
    setActivityEffort(props.task.projectTask.estimatedTime);
  }

  if (activityDuration !== props.task.projectTask.estimatedDays && !durationFocused) {
    setActivityDuration(Math.round(props.task.projectTask.estimatedDays));
  }

  const handleAssign_ = (users_: any) => {
    //console.log(users_);
    let assignedUsers = selectedUsers;
    let usRan = [];
    let usNotRank = [];
    for (let i = 0; i < users_.length; i++) {
      //const usuarios = users_[i].ranking ? JSON.parse(JSON.stringify(rankedUsers)) : JSON.parse(JSON.stringify(notRankedUsers));
      //const usuario = usuarios.find((user: any) => user.id === idUser);
      const usuario = users_[i];
      //console.log(usuario);
      //if (checked) {
      usuario.status = UserStatus.Assigned;
      assignedUsers++;
      projectPlanDispatch({
        type: 'assignUser',
        idUser: usuario.id,
        users: rankedUsers.map((rankedUser: any) => {
          if (rankedUser.id === usuario.id) {
            return { ...rankedUser, status: UserStatus.Assigned }
          }
          return { ...rankedUser }
        }).concat(
          notRankedUsers.map((notRankedUser: any) => {
            if (notRankedUser.id === usuario.id) {
              return { ...notRankedUser, status: UserStatus.Assigned }
            }
            return { ...notRankedUser }
          })
        ),
        taskType: props.task.taskType,
        planIndexes: {
          elementTypeIndex: props.indexes.elementTypeIndex,
          projectElementIndex: props.indexes.elementIndex,
          phaseIndex: props.indexes.phaseIndex,
          taskIndex: props.indexes.taskIndex
        },
        adjustedDuration: !statisticalRange,
        recalculateEstimates: changeValuesOnAssignedUsers
      });

      users_[i].ranking ? usRan.push(users_[i]) : usNotRank.push(users_[i]);
      //}
    }
    if (assignedUsers === 0 && props.task.taskType.duration_avg > 0) {
      setActivityDuration(props.task.taskType.duration_avg);
    }
    setSelectedUsers(users_.length);
    //setRankedUsers(usRan);
    //setNotRankedUsers(usNotRank);
    setUsuariosAsignados(users_);
    /*if (ranked) {
      setRankedUsers(usuarios);
    } else {
      setNotRankedUsers(usuarios);
    }*/
  }

  const removeUser = (usuario: any) => {
    projectPlanDispatch({
      type: 'removeUser',
      user: { ...usuario },
      users: rankedUsers.map((rankedUser: any) => {
        if (rankedUser.id === usuario.id) {
          return { ...rankedUser, status: UserStatus.Unassigned }
        }
        return { ...rankedUser }
      }).concat(
        notRankedUsers.map((notRankedUser: any) => {
          if (notRankedUser.id === usuario.id) {
            return { ...notRankedUser, status: UserStatus.Unassigned }
          }
          return { ...notRankedUser }
        })
      ),
      taskType: props.task.taskType,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex,
        phaseIndex: props.indexes.phaseIndex,
        taskIndex: props.indexes.taskIndex
      },
      adjustedDuration: !statisticalRange,
      recalculateEstimates: changeValuesOnAssignedUsers
    });
    //console.log(usuario);
    //console.log(usuariosAsignados);
    let usAsi = usuariosAsignados.filter((us: any) => us.id != usuario.id);
    setUsuariosAsignados(usAsi);
    setSelectedUsers(usAsi.length);
  }

  const [selPriorityType, setSelPriorityType] = useState(props.priorityTypes.length > 0 ? {value: props.priorityTypes[0].idPriorityType,
    label: props.priorityTypes[0].name} : null);
  const [parents, setParents] = useState(props.task.projectTask.priorities.length > 0 ? props.task.projectTask.priorities[0].parents : null);

  const warningMessageSecuencility = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <TrueffortConfirmAlert
            title={
              <Typography color='primary' variant='h6' fontWeight={700} marginBottom='20px' >
                <InfoIcon sx={{ color: 'primary' }} />&nbsp;&nbsp;{t("Warning")}
              </Typography>
            }
            alertColor='primary'
            messages={["Al ingresar la secuencialidad la estimación se realiza en base a la secuencia establecida"]}
            buttons={[
              {label:"Cancelar", onClick: () => {
                  onClose();
                  setParents(null);
                }
              },
              {
                label: "Aceptar",
                onClick: () => {
                  changePriority();
                  onClose();
                }
              }
            ]}
          />
        );
      }
    });
  }

  useEffect(() => {
    if (selPriorityType && parents) {
      if (props?.plan?.hasSecuency) {
        changePriority();
      } else {
        warningMessageSecuencility();
      }
    }
  }, [selPriorityType, parents])

  const changePriority = () => {
    //console.log(selPriorityType);
    //console.log(parents)
    projectPlanDispatch({
      type: 'changePriority',
      idPriorityType: selPriorityType.value,
      parents: parents,
      hasSecuency: true,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex,
        phaseIndex: props.indexes.phaseIndex,
        taskIndex: props.indexes.taskIndex
      }
    });
  }

  /*const handleCheckboxChange = (checked: boolean, idUser: number, ranked: boolean) => {
    console.log("aqui");
    const usuarios = ranked ? JSON.parse(JSON.stringify(rankedUsers)) : JSON.parse(JSON.stringify(notRankedUsers));
    const usuario = usuarios.find((user: any) => user.id === idUser);
    let assignedUsers = selectedUsers;

    if (checked) {
      usuario.status = UserStatus.Assigned;
      assignedUsers++;
      projectPlanDispatch({
        type: 'assignUser',
        idUser: idUser,
        users: rankedUsers.map((rankedUser: any) => {
          if (rankedUser.id === idUser) {
            return { ...rankedUser, status: UserStatus.Assigned }
          }
          return { ...rankedUser }
        }).concat(
          notRankedUsers.map((notRankedUser: any) => {
            if (notRankedUser.id === idUser) {
              return  { ...notRankedUser, status: UserStatus.Assigned }
            }
            return { ...notRankedUser }
          })
        ),
        taskType: props.task.taskType,
        planIndexes: {
          elementTypeIndex: props.indexes.elementTypeIndex,
          projectElementIndex: props.indexes.elementIndex,
          phaseIndex: props.indexes.phaseIndex,
          taskIndex: props.indexes.taskIndex
        },
        adjustedDuration: !statisticalRange,
        recalculateEstimates: changeValuesOnAssignedUsers
      });

    } else if (selectedUsers > 0) {
      projectPlanDispatch({
        type: 'removeUser',
        user: { ...usuario },
        users: rankedUsers.map((rankedUser: any) => {
          if (rankedUser.id === idUser) {
            return { ...rankedUser, status: UserStatus.Unassigned }
          }
          return { ...rankedUser }
        }).concat(
          notRankedUsers.map((notRankedUser: any) => {
              if (notRankedUser.id === idUser) {
                  return  { ...notRankedUser, status: UserStatus.Unassigned }
              }
              return { ...notRankedUser }
          })
        ),
        taskType: props.task.taskType,
        planIndexes: {
          elementTypeIndex: props.indexes.elementTypeIndex,
          projectElementIndex: props.indexes.elementIndex,
          phaseIndex: props.indexes.phaseIndex,
          taskIndex: props.indexes.taskIndex
        },
        adjustedDuration: !statisticalRange,
        recalculateEstimates: changeValuesOnAssignedUsers
      });

      usuario.status = UserStatus.Unassigned;
      assignedUsers--;
    }

    if (assignedUsers === 0 && props.task.taskType.duration_avg > 0) {
      setActivityDuration(props.task.taskType.duration_avg);
    }
    setSelectedUsers(assignedUsers);
    if (ranked) {
      setRankedUsers(usuarios);
    } else {
      setNotRankedUsers(usuarios);
    }
  }*/

  const handleActivityEffortChange = (value: number) => {
    if (value < 0) {
      setActivityEffort(props.task.projectTask.estimatedTime);
      return;
    }

    projectPlanDispatch({
      type: 'changeEffort',
      newEffortValue: value,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex,
        phaseIndex: props.indexes.phaseIndex,
        taskIndex: props.indexes.taskIndex
      }
    });
  }

  const handleActivityDurationChange = (value: number) => {
    if (value < 0) {
      setActivityDuration(Math.round(props.task.projectTask.estimatedDays));
      return;
    }
    setActivityDuration(value);
    projectPlanDispatch({
      type: 'changeDuration',
      newDurationValue: value,
      level: 3,
      planIndexes: {
        elementTypeIndex: props.indexes.elementTypeIndex,
        projectElementIndex: props.indexes.elementIndex,
        phaseIndex: props.indexes.phaseIndex,
        taskIndex: props.indexes.taskIndex
      },
      adjustedDuration: !statisticalRange
    });
  }

  const handleEffortBlur = () => {
    if (activityEffort === '') {
      //setActivityEffort(Math.round(props.task.projectTask.estimatedTime));
      setActivityEffort(props.task.projectTask.estimatedTime);
    } else {
      //handleActivityEffortChange(Math.round(Number(activityEffort)));
      handleActivityEffortChange(Number(activityEffort));
    }

    setEffortFocussed(false);
  }

  const handleDurationBlur = () => {
    if (activityDuration === '') {
      setActivityDuration(Math.round(props.task.projectTask.estimatedDays));
    } else {
      handleActivityDurationChange(Math.round(Number(activityDuration)));
    }

    setDurationFocused(false);
  }

  const handleEstimatesChangeOnAssignedUsers = () => {
    if (!changeValuesOnAssignedUsers) { // Si se activa el recalculo de estimaciones
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <TrueffortConfirmAlert
              title={
                <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                  <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("Warning")}
                </Typography>
              }
              alertColor='error'
              messages={[
                t("estimation_page.msg_recalculate_estimates_1"),
                t("estimation_page.msg_recalculate_estimates_2")
              ]}
              buttons={[
                {
                  label: t("project_page.msg_delete_task_confirm_no"),
                  onClick: onClose
                },
                {
                  label: t("export_excel.yes"),
                  onClick: () => {
                    projectPlanDispatch({
                      type: 'updateTaskEstimates',
                      users: rankedUsers.map((rankedUser: any) => ({ ...rankedUser }))
                        .concat(
                          notRankedUsers.map((notRankedUser: any) => ({ ...notRankedUser }))
                        ),
                      taskType: props.task.taskType,
                      planIndexes: {
                        elementTypeIndex: props.indexes.elementTypeIndex,
                        projectElementIndex: props.indexes.elementIndex,
                        phaseIndex: props.indexes.phaseIndex,
                        taskIndex: props.indexes.taskIndex
                      },
                      adjustedDuration: !statisticalRange
                    });
                    setChangeValuesOnAssignedUsers(!changeValuesOnAssignedUsers);
                    onClose();
                  }
                }
              ]}
            />
          );
        }
      });
    } else { // Si se desactiva el recalculo de estimaciones
      setChangeValuesOnAssignedUsers(!changeValuesOnAssignedUsers);
    }
  }

  return (
    <>
      {!props.hideTree &&
        <Paper
          variant="outlined"
          square
          sx={{ padding: '10px', backgroundColor: 'rgba(242, 233, 255, 0.30)' }}
        >
          <Grid container spacing={2} alignItems="center" >
            <Grid item xs={0.8} container alignItems='center' justifyContent='center' >
              {(props.task.projectTask.estimatedTime <= 0 ||
                Math.round(props.task.projectTask.estimatedDays) <= 0) &&
                <Tooltip title={t("estimation_page.cero_values_error")} placement='top'>
                  <ErrorIcon color='error' />
                </Tooltip>
              }
            </Grid>
            <Grid item xs={2.7}  >
              <Typography >
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setShowUsers(!showUsers)}
                >
                  {showUsers ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                </IconButton>
                {props.task.taskType.name}
              </Typography>
            </Grid>
            <Grid item xs={1} >
              <Stack direction='row' spacing={1} alignItems='center' justifyContent='center' >
                <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
                  <Typography variant='caption' >
                    {t("estimation_page.average")}
                  </Typography>

                  <TrueffortChip
                    //size='small'
                    color='purple'
                    variant='outlined'
                    label={props.task.taskType.team_sz_avg}
                  />
                </Stack>

                <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
                  <Typography variant='caption' >
                    {t("estimation_page.selected_participants")}
                  </Typography>

                  <TrueffortChip
                    //size='small'
                    color='purple'
                    label={selectedUsers}
                  />
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={3} >
              <Stack direction='row' spacing={1} style={{ padding: '0 2em' }} >
                <Limit
                  isMax={false}
                  label={props.task.taskType.effort_sigma_interval_low}
                  total={props.task.projectTask.estimatedTime}
                  estimatedVal={props.task.taskType.effort_sigma_interval_low}
                  handle={handleActivityEffortChange}
                  disabled={false}
                />
                <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
                  <Typography variant='caption' >{t("estimation_page.avg")}</Typography>
                  <TextField
                    name="estimatedTime"
                    type="number"
                    InputProps={{ inputProps: { min: 1 } }}
                    size="small"
                    //disabled={!isModifiable || !elementType.active}
                    value={effortFocused ? activityEffort : props.task.projectTask.estimatedTime}
                    onFocus={() => setEffortFocussed(true)}
                    onBlur={handleEffortBlur}
                    onChange={(event: any) => effortFocused ? setActivityEffort(event.target.value) :
                      handleActivityEffortChange(Number(event.target.value))
                    }
                    onKeyDown={(event: any) => {
                      if (event.key === "Enter") handleActivityEffortChange(Number(event.target.value));
                    }}
                    error={props.task.projectTask.estimatedTime <= 0 || activityEffort <= 0}
                  />
                </Stack>

                <Limit
                  isMax={true}
                  label={props.task.taskType.effort_sigma_interval_up}
                  total={props.task.projectTask.estimatedTime}
                  estimatedVal={props.task.taskType.effort_sigma_interval_up}
                  handle={handleActivityEffortChange}
                  disabled={false}
                />
              </Stack>
            </Grid>

            <Grid item xs={3} >
              <Stack direction="row" spacing={1} style={{ padding: '0 2em' }}>
                <Limit
                  title="Min"
                  isMax={false}
                  label={props.task.taskType.duration_min}
                  total={Math.round(props.task.projectTask.estimatedDays)}
                  estimatedVal={props.task.taskType.duration_min}
                  handle={handleActivityDurationChange}
                  disabled={false}
                />
                <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
                  <Typography variant='caption' >{t("estimation_page.avg")}</Typography>
                  <TextField
                    name="estimatedDays"
                    type="number"
                    InputProps={{ inputProps: { min: 1 } }}
                    size="small"
                    //disabled={!isModifiable || !elementType.active}
                    value={durationFocused ? activityDuration : props.task.projectTask.estimatedDays}
                    onFocus={() => setDurationFocused(true)}
                    onBlur={handleDurationBlur}
                    onChange={(event: any) =>
                      durationFocused ? setActivityDuration(event.target.value) :
                        handleActivityDurationChange(Math.round(Number(event.target.value)))
                    }
                    onKeyDown={(event: any) => {
                      if (event.key === "Enter") handleActivityDurationChange(Math.round(Number(event.target.value)));
                    }}
                    error={Math.round(props.task.projectTask.estimatedDays) <= 0 || activityDuration <= 0}
                  />
                </Stack>
                <Limit
                  title="Max"
                  isMax={true}
                  label={props.task.taskType.duration_max}
                  total={Math.round(props.task.projectTask.estimatedDays)}
                  estimatedVal={props.task.taskType.duration_max}
                  handle={handleActivityDurationChange}
                  disabled={false}
                />
              </Stack>
            </Grid>
            <Grid item xs={1.5} container justifyContent='end' >
              <TrueffortChip
                icon={<DeleteIcon fontSize="small" />}
                size="small"
                label={t("delete")}
                variant="outlined"
                color='redExtra'
                //disabled={formikTask.isSubmitting}
                onClick={() => props.handleTaskDelete(props.indexes.taskIndex, activityEffort)}
              />
            </Grid>
          </Grid>
        </Paper>
      }
      <Collapse in={showUsers || props.hideTree} timeout="auto" unmountOnExit >
        <Paper
          variant="outlined"
          square
          sx={{ padding: '10px', backgroundColor: 'rgba(242, 233, 255, 0.30)' }}
        >
          <Grid container spacing={1} >
            <Grid item xs={1} ></Grid>
            <Grid item xs={1.5} >
              <Stack direction='column' spacing={1} >
                <Typography variant="subtitle2" >
                  <SvgIcon fontSize="small" >
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.75 2.75V5.5C2.75 5.86467 2.89487 6.21441 3.15273 6.47227C3.41059 6.73013 3.76033 6.875 4.125 6.875H8.70833M8.70833 6.875L6.875 5.04167M8.70833 6.875L6.875 8.70833"
                        stroke="#553D74" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </SvgIcon>
                  {t("estimation_page.participants")}
                </Typography>
                <Chip
                  sx={{ borderRadius: '3px' }}
                  icon={<FontAwesomeIcon icon={faUsers} color={'#9A64E2'} />}
                  label={"Total: " + selectedUsers}
                  variant='outlined'
                />
                <TrueffortButton
                  size="small"
                  variant='outlined'
                  color='secondary'
                  startIcon={<AddIcon />}
                  onClick={() => setShowModal(true)}
                >
                  {t("project_tasks_page.add_user")}
                </TrueffortButton>
              </Stack>
            </Grid>
            <Grid item xs={7}  >
              <Grid container spacing={1} padding={1} alignItems='center' >
                {usuariosAsignados
                  .sort((usr1: any, usr2: any) => usr2.ranking - usr1.ranking)
                  .filter((user: any) => user.status === UserStatus.Assigned)
                  .map((user: any, k: number) => (
                    <Grid item key={k.toString()} >
                      <ProjectDetailUserCard
                        userInfo={user}
                        _deleteUser={removeUser}
                        index={k}
                        detail={false}
                      />
                    </Grid>
                  ))
                }

                {false && notRankedUsers
                  .filter((user: any) => user.status === UserStatus.Assigned)
                  .map((user: any, k: number) => (
                    <Grid item key={k.toString()} >
                      <ProjectDetailUserCard
                        userInfo={user}
                        _deleteUser={removeUser}
                        index={k}
                        detail={false}
                      />
                    </Grid>
                  ))
                }
              </Grid>
            </Grid>
            <Grid item xs={2.5} >
              <FormControlLabel
                control={
                  <Switch
                    checked={changeValuesOnAssignedUsers}
                    onChange={handleEstimatesChangeOnAssignedUsers}
                  />
                }
                label={t("users_modal.recalculate_estimates")}
              />
            </Grid>
            <Grid item xs={1} ></Grid>
            <Grid item xs={11} container spacing={1}>
              <Grid item xs={4}>
                <InputLabel
                    sx={{
                        fontWeight: 700,
                        color: '#4A4A4A',
                        fontSize: '0.75rem'
                    }}
                >
                    {"Tipo de prioridad"}
                </InputLabel>
                <Select
                    name="idsPriorityTypes"
                    placeholder={"Tipos de prioridad"}
                    isDisabled={true}
                    value={selPriorityType}
                    onChange={(option: any) => setSelPriorityType(option)}
                    options={
                        props.priorityTypes.map((pt: any, k: number) => {
                            return ({
                                value: pt.idPriorityType,
                                label: pt.name
                            })
                        })
                    }
                    styles={styleReactSelect}
                >
                </Select>
              </Grid>
              <Grid item xs={8}>
                <InputLabel sx={{ fontWeight: 700, color: '#4A4A4A', fontSize: '0.75rem'}}
                > {"Actividad predecesora"}</InputLabel>
                <Select
                    name="idsActivities"
                    value={parents}
                    isMulti={false}
                    onChange={(option: any) => setParents([option])}
                    options={
                      listActivities.map((act: any, k: number) => {
                          return ({
                              value: act.id,
                              label: act.fullName,
                              data: act
                          })
                      })
                    }
                    styles={styleReactSelect}
                >
                </Select>
              </Grid>
              {//props.task.projectTask.fullName + " < --- > " + props.task.projectTask.id
              }
              
              <Grid item xs={4}>
                <DatePicker
                  style={{width:'100%'}}
                  dateFormat="dd/MM/yyyy"
                  selected={new Date(props.task.projectTask.estimatedStartDate)}
                  onChange={(date:any) => projectPlanDispatch({
                    type: 'changeEstimatedStartDate',
                    planIndexes: {
                      elementTypeIndex: props.indexes.elementTypeIndex,
                      projectElementIndex: props.indexes.elementIndex,
                      phaseIndex: props.indexes.phaseIndex,
                      taskIndex: props.indexes.taskIndex
                    },
                    estimatedStartDate: date
                  })}
                  customInput={<TrueffortTextField 
                    size="small" 
                    name="registredDate"
                    fullWidth
                    labelstring={"Fecha estimada de inicio"}
                  />}
                />
              </Grid>
              <Grid item xs={4}>
              <InputLabel
                    sx={{
                        fontWeight: 700,
                        color: '#4A4A4A',
                        fontSize: '0.75rem'
                    }}
                >
                    {"Fecha estimada de fin"}
                </InputLabel>
                {formatDateString(props.task.projectTask.estimatedFinishDate, "dd/MM/yyyy", null, false)}
              </Grid>
              {/*props.task.projectTask.estimatedStartDate +" - " +props.task.projectTask.estimatedFinishDate*/}
            </Grid>
          </Grid>
        </Paper>
      </Collapse>

      <AssignUsersDrawer
        //key={Math.random().toString()}
        open={showModal}
        anchor='right'
        onClose={() => setShowModal(false)}
        users={{
          notRankedUsers: notRankedUsers,
          rankedUsers: rankedUsers.sort(
            (usr1: any, usr2: any) => usr2.ranking - usr1.ranking
          )
        }}
        setUsers={{ setNotRankedUsers: setNotRankedUsers, setRankedUsers: setRankedUsers }}
        taskName={props.task.taskType.name}
        assignUsers={handleAssign_}
        page='detail'
        usuariosAsignados={usuariosAsignados}
      />
    </>
  );
}